<template>
  <div class="welcome-container">
    <!-- 筛选条件 -->
    <div class="search">
      <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 12px;">
        <span style="color: #606266; font-size: 14px;">赛季</span>
        <el-select
          v-if="periodType === 'year'"
          v-model="selectedYear"
          placeholder="请选择年份"
          style="width: 140px;"
          size="small"
          @change="getData"
        >
          <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="y"></el-option>
        </el-select>
        <el-select
          v-if="periodType === 'quarter'"
          v-model="selectedYear"
          placeholder="请选择年份"
          style="width: 140px; margin-left: 8px;"
          size="small"
          @change="getData"
        >
          <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="y"></el-option>
        </el-select>
        <el-select
          v-if="periodType === 'quarter'"
          v-model="selectedQuarter"
          placeholder="请选择季度"
          style="width: 120px;"
          size="small"
          @change="getData"
        >
          <el-option label="Q1" value="Q1"></el-option>
          <el-option label="Q2" value="Q2"></el-option>
          <el-option label="Q3" value="Q3"></el-option>
          <el-option label="Q4" value="Q4"></el-option>
        </el-select>
        <el-select
          v-if="periodType === 'month'"
          v-model="selectedYear"
          placeholder="请选择年份"
          style="width: 140px; margin-left: 8px;"
          size="small"
          @change="getData"
        >
          <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="y"></el-option>
        </el-select>
        <el-select
          v-if="periodType === 'month'"
          v-model="selectedMonth"
          placeholder="请选择月份"
          style="width: 120px;"
          size="small"
          @change="getData"
        >
          <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="m"></el-option>
        </el-select>
        <!-- <span style="color: #606266; font-size: 14px; margin-left: 8px;">销售人员</span>
        <el-select
          v-model="selectedPerson"
          placeholder="请选择人员"
          style="width: 140px;"
          size="small"
          @change="getData"
        >
          <el-option
            v-for="p in personList"
            :key="p.id"
            :label="p.name"
            :value="p.id"
          ></el-option>
        </el-select> -->
      </div>
    </div>

    <!-- 个人业绩概览卡片 -->
    <div class="top-card">
      <div class="top-card-item" v-for="(card, idx) in summaryCards" :key="idx">
        <div class="panel-item" :class="'panel' + idx">
          <div class="panel-label">{{ card.label }}</div>
          <div class="panel-num">{{ card.value }}<span>{{ card.unit }}</span></div>
          <!-- <div class="panel-sub">
            <span class="sub-rate" :style="{ color: card.rate >= 0 ? '#67C23A' : '#F56C6C' }">
              <i :class="card.rate >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
              {{ Math.abs(card.rate) }}%
            </span>
            <span class="sub-text">环比{{ card.rate >= 0 ? '增长' : '下降' }}</span>
          </div> -->
        </div>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :span="12">
        <!-- 各部门业绩总览 -->
        <div class="mycard" style="margin-bottom: 20px;">
          <div class="title222">赛区业绩总览</div>
          <div class="echarts" id="deptPerformanceChart"></div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="mycard" style="margin-bottom: 20px;">
          <div class="title222">各项目营收与完成率总览</div>
          <div class="echarts" id="projectRevenueChart"></div>
        </div>
      </el-col>
    </el-row>

    <!-- 各部门切换 -->
    <el-card>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="华北" name="1"></el-tab-pane>
        <el-tab-pane label="华东" name="2"></el-tab-pane>
        <el-tab-pane label="华南" name="3"></el-tab-pane>
        <el-tab-pane label="西南" name="4"></el-tab-pane>
        <el-tab-pane label="全国" name="5"></el-tab-pane>
        <el-tab-pane label="营地ToC" name="6"></el-tab-pane>
      </el-tabs>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="mycard card1" style="margin-bottom: 20px;">
            <div class="title222">赛区当前各项目完成情况</div>
            <div class="flex">
              <div class="item1">
                <div class="item1-tit">当前完成</div>
                <div class="item1-tit">业绩任务</div>
              </div>
              <div class="echarts" id="enrollmentCompareChart"></div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <!-- 月度趋势折线图 -->
            <div class="mycard card1" style="margin-bottom: 20px;">
              <div class="title222">
                <!-- {{ periodType === 'year' ? selectedYear + '年' : periodType === 'quarter' ? selectedYear + '年 ' + selectedQuarter : selectedYear + '年 ' + selectedMonth + '月' }} -->
                月度完成率
              </div>
              <div class="echarts" id="trendLineChart"></div>
            </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <el-tabs v-model="activeName2" type="card">
        <el-tab-pane label="SPBCN个人赛" name="1"></el-tab-pane>
        <el-tab-pane label="ITSO团体赛" name="2"></el-tab-pane>
        <el-tab-pane label="CEBSB汉英双拼" name="3"></el-tab-pane>
        <el-tab-pane label="NASCC北美冠军挑战赛" name="4"></el-tab-pane>
        <el-tab-pane label="ASBC亚洲杯" name="5"></el-tab-pane>
        <el-tab-pane label="WSA拼词世界杯" name="6"></el-tab-pane>
      </el-tabs>
      <div class="data-tt">本赛季数据</div>
      <el-row :gutter="20">
        <!-- 赛事数据 -->
        <el-col :span="6" v-for="(item, i) in dataList" :key="i">
        <div class="data-card">
          <div class="tit">{{ item.title }}</div>
          <div class="val" v-if="item.rate">{{ item.rate }}<span>%</span></div>
          <div class="val" v-else>{{ item.value }}</div>
        </div>
        </el-col>
      </el-row>
      <div class="data-tt">上赛季数据</div>
      <el-row :gutter="20">
        <!-- 赛事数据 -->
        <el-col :span="6" v-for="(item, i) in lastYearList" :key="i">
        <div class="data-card">
          <div class="tit">{{ item.title }}</div>
          <div class="flex111">
            <div class="val" v-if="item.rate">{{ item.rate }}<span>%</span></div>
            <div class="val" v-else>{{ item.value }}</div>
            <div class="up" v-if="item.up">
              <i class="el-icon-top"></i>
              {{ item.up }}
            </div>
          </div>
        </div>
        </el-col>
      </el-row>
    </el-card>

  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'salesPerformanceDashboard',
  data () {
    return {
      periodType: 'year',
      selectedYear: new Date().getFullYear(),
      selectedQuarter: 'Q1',
      selectedMonth: new Date().getMonth() + 1,
      selectedPerson: '1',
      yearOptions: [
        '2023~2024', '2024~2025', '2025~2026'
      ],
      personList: [
        { id: '1', name: '张三' },
        { id: '2', name: '李四' },
        { id: '3', name: '王五' }
      ],
      summaryCards: [],
      enrollmentChart: null,
      deptPerformanceChart: null,
      projectRevenueChart: null,
      trendChart: null,
      activeName: '1',
      activeName2: '1',
      dataList: [
        {
          title: 'B端数据总数',
          value: 548
        },
        {
          title: '集体参赛校',
          value: 219
        },
        {
          title: '本赛季新录入',
          value: 10
        },
        {
          title: '待分配数据',
          value: 7
        },
        {
          title: '跟进中',
          value: 108
        },
        {
          title: '确认参赛',
          value: 45
        },
        {
          title: '拒绝参赛',
          value: 59
        },
        {
          title: '确认考量',
          value: 1245
        },
        {
          title: '已上传初赛成绩',
          value: 8521
        },
        {
          title: '网络初赛报名人数',
          value: 800
        },
        {
          title: '初赛晋级人数',
          value: 3975
        },
        {
          title: '复赛报名人数',
          value: 1800
        },
        {
          title: '初转复转化率',
          rate: '70'
        }
      ],
      lastYearList: [
        {
          title: '参赛校',
          value: 39,
          up: 20
        },
        {
          title: '初赛考量',
          value: 9732
        },
        {
          title: '复赛报名人数',
          value: 1200
        },
        {
          title: '初转复转化率',
          rate: '70'
        }
      ]
    }
  },
  mounted () {
    this.initYearOptions()
    this.$nextTick(() => {
      this.getData()
    })
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeCharts)
    this.destroyCharts()
  },
  methods: {
    initYearOptions () {
      // const currentYear = new Date().getFullYear()
      // this.yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i)
    },
    handlePeriodChange () {
      this.selectedYear = new Date().getFullYear()
      if (this.periodType === 'quarter') {
        this.selectedQuarter = 'Q1'
      } else if (this.periodType === 'month') {
        this.selectedMonth = new Date().getMonth() + 1
      }
      this.getData()
    },
    getData () {
      this.buildSummaryCards()
      this.$nextTick(() => {
        this.initEnrollmentCompareChart()
        this.initDeptPerformanceChart()
        this.initProjectRevenueChart()
        this.initTrendLineChart()
      })
    },
    buildSummaryCards () {
      // 模拟数据,按人员、年份、周期返回不同数值
      // const seed = this.selectedPerson.charCodeAt(0) + this.selectedYear
      // const periodOffset = this.periodType === 'year' ? 0 : this.periodType === 'quarter' ? this.selectedQuarter.charCodeAt(1) : this.selectedMonth
      // const mul = (n) => Math.abs((seed * periodOffset * 17 + n * 31) % 100)

      this.summaryCards = [
        {
          label: '年度销售总任务',
          value: '3000',
          unit: '万元'
        },
        {
          label: '当前累计完成',
          value: '2100',
          unit: '万元'
        },
        {
          label: '当前完成率',
          value: '81',
          unit: '%'
        },
        {
          label: '本季度完成率',
          value: '79',
          unit: '%'
        },
        {
          label: '本周实时',
          value: '21',
          unit: '万元'
        }
      ]
    },
    initEnrollmentCompareChart () {
      const el = document.getElementById('enrollmentCompareChart')
      if (!el) return
      if (this.enrollmentChart) this.enrollmentChart.dispose()
      this.enrollmentChart = echarts.init(el)

      const personSeed = this.selectedPerson.charCodeAt(0)
      const yearSeed = this.selectedYear % 100
      const taskBase = (v) => Math.abs((personSeed * yearSeed * v * 29) % 400) + 300
      const actualBase = (v) => Math.abs((personSeed * yearSeed * v * 17) % 500) + 200

      const projects = ['个人赛', '团体赛', '营地', '汉英', '其他']
      const tasks = projects.map((_, i) => taskBase(i + 1))
      const actuals = projects.map((_, i) => actualBase(i + 1))

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: function (params) {
            const axis = params[0].name
            let res = axis + '<br/>'
            params.forEach(p => {
              const val = Math.abs(p.value)
              res += '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + p.color + '"></span>' + p.seriesName + ': ' + val + ' 万元<br/>'
            })
            return res
          }
        },
        legend: {
          data: ['当前完成金额', '业绩任务'],
          bottom: 0
        },
        color: ['#67C23A', '#409EFF'],
        grid: { left: '3%', right: '4%', bottom: '12%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: projects,
          axisLabel: { color: '#606266', fontSize: 12 },
          axisLine: { lineStyle: { color: '#DCDFE6' } }
        },
        yAxis: {
          type: 'value',
          name: '万元',
          axisLabel: {
            color: '#606266',
            formatter: function (val) {
              return Math.abs(val)
            }
          },
          splitLine: { lineStyle: { color: '#F0F0F0' } }
        },
        series: [
          {
            name: '当前完成金额',
            type: 'bar',
            barWidth: 20,
            data: actuals.map((val, i) => ({
              value: val,
              itemStyle: { color: val >= tasks[i] ? '#07C66E' : '#F63549' }
            })),
            label: { show: true, position: 'top', fontSize: 11, formatter: function (p) { return Math.abs(p.value) } },
            barGap: '10%'
          },
          {
            name: '业绩任务',
            type: 'bar',
            barWidth: 20,
            data: tasks.map(t => -t),
            itemStyle: { color: '#0255F7' },
            label: { show: true, position: 'bottom', fontSize: 11, formatter: function (p) { return Math.abs(p.value) } },
            barGap: '10%'
          }
        ]
      }
      this.enrollmentChart.setOption(option)
    },
    initDeptPerformanceChart () {
      const el = document.getElementById('deptPerformanceChart')
      if (!el) return
      if (this.deptPerformanceChart) this.deptPerformanceChart.dispose()
      this.deptPerformanceChart = echarts.init(el)

      const personSeed = this.selectedPerson.charCodeAt(0)
      const yearSeed = this.selectedYear % 100
      const base = (v) => Math.abs((personSeed * yearSeed * v * 17) % 600) + 100
      const rate = (v) => Number((Math.abs((personSeed * yearSeed * v * 7) % 60) + 20).toFixed(1))

      const districts = ['华北', '华东', '华南', '西南', '全国']
      const amounts = districts.map((_, i) => base(i + 1))
      const rates = districts.map((_, i) => rate(i + 1))

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        legend: {
          data: ['完成金额', '完成率'],
          bottom: 0
        },
        color: ['#409EFF', '#67C23A'],
        grid: { left: '3%', right: '10%', bottom: '12%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: districts,
          axisLabel: { color: '#606266' },
          axisLine: { lineStyle: { color: '#DCDFE6' } }
        },
        yAxis: [
          {
            type: 'value',
            name: '完成金额(万元)',
            axisLabel: { color: '#606266', formatter: '{value}' },
            splitLine: { lineStyle: { color: '#F0F0F0' } }
          },
          {
            type: 'value',
            name: '完成率 %',
            axisLabel: { color: '#606266', formatter: '{value}%' },
            splitLine: { show: false },
            min: 0,
            max: 100
          }
        ],
        series: [
          {
            name: '完成金额',
            type: 'bar',
            barWidth: 30,
            yAxisIndex: 0,
            data: amounts,
            label: { show: true, position: 'top', fontSize: 11, color: '#1f30c7' },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#1f30c7' },
                { offset: 1, color: '#79bbff' }
              ])
            }
          },
          {
            name: '完成率',
            type: 'line',
            smooth: false,
            yAxisIndex: 1,
            data: rates,
            label: { show: true, position: 'top', fontSize: 11, color: '#F9801E', formatter: '{c}%' },
            itemStyle: { color: '#F9801E' },
            lineStyle: { width: 2 },
            symbol: 'circle',
            symbolSize: 8
          }
        ]
      }
      this.deptPerformanceChart.setOption(option)
    },
    initProjectRevenueChart () {
      const el = document.getElementById('projectRevenueChart')
      if (!el) return
      if (this.projectRevenueChart) this.projectRevenueChart.dispose()
      this.projectRevenueChart = echarts.init(el)

      const personSeed = this.selectedPerson.charCodeAt(0)
      const yearSeed = this.selectedYear % 100
      const base = (v) => Math.abs((personSeed * yearSeed * v * 23) % 500) + 80
      const rate = (v) => Number((Math.abs((personSeed * yearSeed * v * 9) % 55) + 25).toFixed(1))

      const projects = ['个人赛', '团体赛', '营地', '汉英', '其他']
      const amounts = projects.map((_, i) => base(i + 1))
      const rates = projects.map((_, i) => rate(i + 1))

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        legend: {
          data: ['完成金额', '完成率'],
          bottom: 0
        },
        color: ['#409EFF', '#67C23A'],
        grid: { left: '3%', right: '10%', bottom: '12%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: projects,
          axisLabel: { color: '#606266' },
          axisLine: { lineStyle: { color: '#DCDFE6' } }
        },
        yAxis: [
          {
            type: 'value',
            name: '完成金额(万元)',
            axisLabel: { color: '#606266', formatter: '{value}' },
            splitLine: { lineStyle: { color: '#F0F0F0' } }
          },
          {
            type: 'value',
            name: '完成率 %',
            axisLabel: { color: '#606266', formatter: '{value}%' },
            splitLine: { show: false },
            min: 0,
            max: 100
          }
        ],
        series: [
          {
            name: '完成金额',
            type: 'bar',
            barWidth: 30,
            yAxisIndex: 0,
            data: amounts,
            label: { show: true, position: 'top', fontSize: 11, color: '#67C23A' },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#67C23A' },
                { offset: 1, color: '#79bbff' }
              ])
            }
          },
          {
            name: '完成率',
            type: 'line',
            smooth: false,
            yAxisIndex: 1,
            data: rates,
            label: { show: true, position: 'top', fontSize: 11, color: '#F9801E', formatter: '{c}%' },
            itemStyle: { color: '#F9801E' },
            lineStyle: { width: 2 },
            symbol: 'circle',
            symbolSize: 8
          }
        ]
      }
      this.projectRevenueChart.setOption(option)
    },
    initTrendLineChart () {
      const el = document.getElementById('trendLineChart')
      if (!el) return
      if (this.trendChart) this.trendChart.dispose()
      this.trendChart = echarts.init(el)

      const personSeed = this.selectedPerson.charCodeAt(0)
      const yearSeed = this.selectedYear % 100
      const rate = (v) => Number((Math.abs((personSeed * yearSeed * v * 19) % 55) + 15).toFixed(1))
      const prevRate = (v) => Number((Math.abs((personSeed * yearSeed * v * 13) % 45) + 10).toFixed(1))

      const months = ['7月', '8月', '9月', '10月', '11月', '12月', '1月', '2月', '3月', '4月', '5月', '6月']
      const currentRates = months.map((_, i) => rate(i + 1))
      const prevRates = months.map((_, i) => prevRate(i + 1))

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = params[0].name + '<br/>'
            params.forEach(p => {
              res += '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + p.color + '"></span>' + p.seriesName + ': ' + p.value + '%<br/>'
            })
            return res
          }
        },
        legend: {
          data: ['当前赛季', '上一赛季'],
          bottom: 0
        },
        color: ['#1f30c7', '#F56C6C'],
        grid: { left: '3%', right: '4%', bottom: '12%', top: '10%', containLabel: true },
        xAxis: {
          type: 'category',
          data: months,
          axisLabel: { color: '#606266' },
          axisLine: { lineStyle: { color: '#DCDFE6' } }
        },
        yAxis: {
          type: 'value',
          name: '完成率 %',
          axisLabel: { color: '#606266', formatter: '{value}%' },
          splitLine: { lineStyle: { color: '#F0F0F0' } },
          min: 0,
          max: 100
        },
        series: [
          {
            name: '当前赛季',
            type: 'line',
            smooth: false,
            data: currentRates,
            label: { show: true, position: 'top', fontSize: 11, color: '#1f30c7', formatter: '{c}%' },
            itemStyle: { color: '#1f30c7' },
            lineStyle: { width: 3 },
            symbol: 'circle',
            symbolSize: 8
          },
          {
            name: '上一赛季',
            type: 'line',
            smooth: true,
            data: prevRates,
            label: { show: true, position: 'top', fontSize: 11, color: '#F56C6C', formatter: '{c}%' },
            itemStyle: { color: '#F56C6C' },
            lineStyle: { width: 3, type: 'dashed' },
            symbol: 'circle',
            symbolSize: 8
          }
        ]
      }
      this.trendChart.setOption(option)
    },
    getPeriodLabels () {
      if (this.periodType === 'year') {
        return ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
      } else if (this.periodType === 'quarter') {
        const q = this.selectedQuarter
        const quarters = {
          Q1: ['1月', '2月', '3月'],
          Q2: ['4月', '5月', '6月'],
          Q3: ['7月', '8月', '9月'],
          Q4: ['10月', '11月', '12月']
        }
        return quarters[q] || []
      } else {
        // 月度 -> 每周
        return ['第1周', '第2周', '第3周', '第4周']
      }
    },
    resizeCharts () {
      this.enrollmentChart && this.enrollmentChart.resize()
      this.deptPerformanceChart && this.deptPerformanceChart.resize()
      this.projectRevenueChart && this.projectRevenueChart.resize()
      this.trendChart && this.trendChart.resize()
    },
    destroyCharts () {
      this.enrollmentChart && this.enrollmentChart.dispose()
      this.deptPerformanceChart && this.deptPerformanceChart.dispose()
      this.projectRevenueChart && this.projectRevenueChart.dispose()
      this.trendChart && this.trendChart.dispose()
    }
  }
}
</script>

<style lang="less" scoped>
.welcome-container {
  padding: 0;
}
.search {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.top-card{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .top-card-item{
    width: 20%;
    box-sizing: border-box;
    padding: 10px;
  }
}
.panel-item {
  background: #fff;
  padding: 20px 24px;
  border-radius: 8px;
  border-left: 6px solid;
  margin-bottom: 0;
  transition: box-shadow 0.3s;
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .panel-label {
    color: #a1a1a1;
    font-size: 14px;
    margin-bottom: 8px;
  }
  .panel-num {
    font-size: 32px;
    font-family: hzgb, "PingFang SC", "Microsoft YaHei", sans-serif;
    color: #303133;
    line-height: 1.2;
    margin-bottom: 8px;
    span{
      font-size: 14px;
      color: #999;
      margin-left: 4px;
    }
  }
  .panel-sub {
    display: flex;
    align-items: center;
    gap: 6px;
    .sub-rate {
      font-size: 13px;
      font-weight: 600;
    }
    .sub-text {
      font-size: 12px;
      color: #909399;
    }
  }
}
.panel0 { border-left-color: #409EFF; }
.panel1 { border-left-color: #E6A23C; }
.panel2 { border-left-color: #67C23A; }
.panel3 { border-left-color: #F56C6C; }
.panel4 { border-left-color: #795cf7; }
.mycard {
  background: #fff;
  padding: 20px 24px;
  border-radius: 8px;
  margin-bottom: 0;
  .title222 {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #F0F0F0;
  }
}
.card1{
  background-color: rgba(236, 245, 255, .5);
}
.echarts {
  width: 100%;
  height: 300px;
}
.flex{
  display: flex;
  align-items: center;
  .item1{
    margin-bottom: 20px;
    .item1-tit{
      height: 120px;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      color: #303133;
      writing-mode: vertical-rl;
    }
  }
}
.data-tt{
  text-align: center;
  padding: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
.data-card{
  background-color: rgba(236, 245, 255, 1);
  border-radius: 6px;
  margin-bottom: 20px;
  width: 160px;
  height: 100px;
  padding: 10px 20px;
  box-sizing: border-box;
  .flex111{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
  .tit{
    font-size: 14px;
    color: #999;
    margin-bottom: 10px;
  }
  .val{
    font-size: 32px;
    font-family: hzgb, "PingFang SC", "Microsoft YaHei", sans-serif;
    color: #000;
    span{
      font-size: 14px;
      color: #999;
      margin-left: 4px;
    }
  }
  .up{
    color: #F63549;
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
